<template>
    <form @submit.prevent="save" class="modal_content">
        <div class="row">
            <div class="col-xs-12 col-sm-7 m_md_bottom_15" :class="{ 'has-error': errors['name'] }">
                <label>{{ $t('name') }}</label>
                <input type="text" v-model="record.name" class="form-control" v-pml-focus ref="mainInput">
                <span class="error" v-if="errors['name']">{{ errors['name'][0] }}</span>
            </div>
            <div class="col-xs-5 col-sm-5 col-md-2" :class="{ 'has-error': errors['active'] }">
                <label>{{ $t('active') }}</label>
                <div class="m-t-5">
                    <pml-switch v-model="record.active" :value="record.active"></pml-switch>
                </div>
                <span class="error" v-if="errors['active']">{{ errors['active'][0] }}</span>
            </div>
            <div class="col-xs-7 col-sm-7 col-md-3 m-t-23 t_right">
                <router-link :to="{ name: 'product-categories.index' }" class="btn btn-white btn_na">{{ $t('cancel') }}</router-link>
                <button type="submit" class="btn btn-default" v-pml-block="isSaving">{{ $t('save') }}</button>
            </div>
        </div>
    </form>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { create, update } from 'services/product-categories'
    import { mapGetters } from 'vuex'
    import { find, isNil, cloneDeep } from 'lodash'

    export default {
        name: 'ProductCategoriesForm',
        data () {
            return {
                record: {
                    active: 1
                },
                errors: [],
                isSaving: false
            }
        },
        mounted () {
            this.init()
        },
        watch: {
            '$route' () {
                this.init()
            }
        },
        computed: {
            ...mapGetters({
                'categories': 'getCategories'
            })
        },
        methods: {
            init () {
                typeof this.$route.params.id !== 'undefined' ? this.fetchRecord(this.$route.params.id) : this.clear()
            },
            fetchRecord (id) {
                this.record = cloneDeep(find(this.categories, { id: parseInt(id) }))
            },
            save () {
                this.isSaving = true

                this.request()
                    .then(() => {
                        Notify.success(trans('the_record_has_been_saved'))
                        this.$router.push({ name: 'product-categories.index' })
                    })
                    .catch(error => {
                        Notify.error(trans('_notifications.error'))
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isSaving = false })
            },
            request () {
                return isNil(this.record.id) ? create(this.record) : update(this.$route.params.id, this.record)
            },
            clear () {
                this.record = {
                    active: 1
                }
                this.errors = []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/product_categories/components/Form.vue